import React from 'react';

function Card({ label, value, tone = 'default' }) {
  return (
    <article className={`op-card op-card-${tone}`}>
      <span className="op-card-label">{label}</span>
      <strong className="op-card-value">{value}</strong>
    </article>
  );
}

function fmtDay(isoDate) {
  const dt = new Date(isoDate);
  if (Number.isNaN(dt.getTime())) return String(isoDate || '');
  return dt.toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit' });
}

export default function OperationalMetricsPanel({
  metrics,
  loading,
  days,
  onChangeDays,
  onRefresh,
  isAdmin,
}) {
  const summary = metrics?.summary || {};
  const assemblies = summary.assemblies || {};
  const reports = summary.reports || {};
  const evidences = summary.evidences || {};
  const logins = summary.logins || {};
  const users = metrics?.users || [];
  const daily = metrics?.daily || [];

  return (
    <section className="op-metrics-wrap">
      <div className="op-metrics-head">
        <div>
          <h3>Metricas Operativas</h3>
          <p>
            Alcance: {metrics?.scope === 'global' ? 'Global' : 'Individual'} · Ventana: {days} dias
          </p>
        </div>
        <div className="op-metrics-controls">
          <label>
            Ventana
            <select value={days} onChange={(e) => onChangeDays(Number(e.target.value))}>
              <option value={7}>7 dias</option>
              <option value={14}>14 dias</option>
              <option value={30}>30 dias</option>
              <option value={60}>60 dias</option>
              <option value={90}>90 dias</option>
            </select>
          </label>
          <button className="btn-ghost" onClick={() => onRefresh(days)} disabled={loading}>
            {loading ? 'Actualizando...' : 'Actualizar'}
          </button>
        </div>
      </div>

      <div className="op-cards-grid">
        <Card label="Asambleas" value={assemblies.total || 0} />
        <Card label="Pendientes" value={assemblies.pending || 0} />
        <Card label="En progreso" value={assemblies.inProgress || 0} />
        <Card label="Completadas" value={assemblies.completed || 0} tone="success" />
        <Card label="Canceladas" value={assemblies.canceled || 0} tone="danger" />
        <Card label="Reportes enviados" value={reports.submitted || 0} />
        <Card label="Evidencias" value={evidences.total || 0} />
        <Card label="Asistentes" value={reports.attendeesTotal || 0} />
        <Card label="Login exitoso %" value={`${logins.successRate || 0}%`} tone="accent" />
      </div>

      <div className="op-metrics-grid">
        <article className="op-panel">
          <h4>{isAdmin ? 'Desempeno por usuario' : 'Mis asambleas'}</h4>
          <div className="op-table-wrap">
            <table className="op-table">
              <thead>
                <tr>
                  <th>Usuario</th>
                  <th>Total</th>
                  <th>Comp.</th>
                  <th>Pend.</th>
                  <th>Cancel.</th>
                  <th>% cierre</th>
                </tr>
              </thead>
              <tbody>
                {users.length === 0 && (
                  <tr>
                    <td colSpan={6} className="op-empty">Sin datos</td>
                  </tr>
                )}
                {users.map((item) => (
                  <tr key={item.userId}>
                    <td>
                      <strong>{item.fullName || '-'}</strong>
                      <span className="op-muted">{item.email}</span>
                    </td>
                    <td>{item.total}</td>
                    <td>{item.completed}</td>
                    <td>{item.pending}</td>
                    <td>{item.canceled}</td>
                    <td>{item.completionRate}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </article>

        <article className="op-panel">
          <h4>Tendencia diaria</h4>
          <div className="op-table-wrap">
            <table className="op-table">
              <thead>
                <tr>
                  <th>Dia</th>
                  <th>Asambleas</th>
                  <th>Reportes</th>
                  <th>Login OK</th>
                  <th>Login Fail</th>
                </tr>
              </thead>
              <tbody>
                {daily.length === 0 && (
                  <tr>
                    <td colSpan={5} className="op-empty">Sin datos</td>
                  </tr>
                )}
                {daily.map((item) => (
                  <tr key={item.day}>
                    <td>{fmtDay(item.day)}</td>
                    <td>{item.assembliesCreated}</td>
                    <td>{item.reportsSubmitted}</td>
                    <td>{item.loginSuccess}</td>
                    <td>{item.loginFailed}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </article>
      </div>
    </section>
  );
}
